const IMG = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1400&q=80`;

export const PRODUCTS = [
  {
    key: "mais",
    category: "raw",
    img: "/assets/mais.jpg",
    fr: {
      name: "Maïs",
      desc: "Maïs grain destiné à l'alimentation humaine et animale, séché et calibré selon vos spécifications.",
      specs: [
        ["Origine", "Côte d'Ivoire"],
        ["Humidité", "≤ 13 %"],
        ["Qualité", "Grade 1 & 2, grains entiers"],
        ["Impuretés", "≤ 2 %"],
      ],
      packing: [
        ["Conditionnement", "Sacs PP de 25 ou 50 kg, ou vrac"],
        ["Logistique", "Conteneur 20' / 40' ou break-bulk"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Quantité min.", "1 conteneur (≈ 27 tonnes)"],
      ],
    },
    en: {
      name: "Corn",
      desc: "Grain corn for human and animal consumption, dried and graded to your specifications.",
      specs: [
        ["Origin", "Côte d'Ivoire"],
        ["Moisture", "≤ 13%"],
        ["Quality", "Grade 1 & 2, whole kernels"],
        ["Foreign matter", "≤ 2%"],
      ],
      packing: [
        ["Packaging", "25 or 50 kg PP bags, or bulk"],
        ["Logistics", "20' / 40' container or break-bulk"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Min. quantity", "1 container (≈ 27 t)"],
      ],
    },
  },
  {
    key: "cajou",
    category: "raw",
    img: "/assets/cajou-brut.jpg",
    fr: {
      name: "Noix de cajou",
      desc: "Noix de cajou brutes en coque, collectées auprès des producteurs de Côte d'Ivoire et préparées pour l'export.",
      specs: [
        ["Origine", "Côte d'Ivoire"],
        ["Outturn", "42 – 50 lbs"],
        ["Humidité", "≤ 10 %"],
        ["Type", "Noix brutes en coque"],
      ],
      packing: [
        ["Conditionnement", "Sacs jute/PP 80 kg"],
        ["Logistique", "Conteneur 20' / 40'"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Quantité min.", "1 conteneur 20'"],
      ],
    },
    en: {
      name: "Cashew nuts",
      desc: "Raw in-shell cashew nuts, collected from producers in Côte d'Ivoire and prepared for export.",
      specs: [
        ["Origin", "Côte d'Ivoire"],
        ["Outturn", "42 – 50 lbs"],
        ["Moisture", "≤ 10%"],
        ["Type", "Raw in-shell nuts"],
      ],
      packing: [
        ["Packaging", "80 kg jute/PP bags"],
        ["Logistics", "20' / 40' container"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Min. quantity", "1 × 20' container"],
      ],
    },
  },
  {
    key: "cafe",
    category: "raw",
    img: IMG("photo-1675306408031-a9aad9f23308"),
    fr: {
      name: "Café",
      desc: "Arabica et robusta en lots tracés jusqu'à la coopérative, profils de tasse contrôlés avant expédition.",
      specs: [
        ["Variétés", "Arabica, Robusta"],
        ["Origine", "Côte d'Ivoire, Éthiopie"],
        ["Tamisage", "15+"],
        ["Humidité", "≤ 12,5 %"],
      ],
      packing: [
        ["Conditionnement", "Sacs 60 kg, liner GrainPro sur demande"],
        ["Logistique", "Conteneur 20'"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Quantité min.", "1 conteneur"],
      ],
    },
    en: {
      name: "Coffee",
      desc: "Arabica and robusta in lots traced back to the cooperative, with cup profiles checked before shipment.",
      specs: [
        ["Varieties", "Arabica, Robusta"],
        ["Origin", "Côte d'Ivoire, Ethiopia"],
        ["Screen size", "15+"],
        ["Moisture", "≤ 12.5%"],
      ],
      packing: [
        ["Packaging", "60 kg bags, GrainPro liner on request"],
        ["Logistics", "20' container"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Min. quantity", "1 container"],
      ],
    },
  },
  {
    key: "cacao",
    category: "raw",
    img: IMG("photo-1545567724-9b16e57c906d"),
    fr: {
      name: "Cacao",
      desc: "Fèves fermentées et séchées, qualité fine de saveur, avec certification disponible sur demande.",
      specs: [
        ["Type", "Fèves fine de saveur, fermentées et séchées"],
        ["Origine", "Côte d'Ivoire, Ghana"],
        ["Humidité", "≤ 7,5 %"],
        ["Comptage", "100 – 110 fèves / 100 g"],
      ],
      packing: [
        ["Conditionnement", "Sacs jute 65 kg"],
        ["Certification", "Rainforest / UTZ sur demande"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Quantité min.", "1 conteneur"],
      ],
    },
    en: {
      name: "Cocoa",
      desc: "Fermented and dried fine-flavor beans, with certification available on request.",
      specs: [
        ["Type", "Fine-flavor beans, fermented and dried"],
        ["Origin", "Côte d'Ivoire, Ghana"],
        ["Moisture", "≤ 7.5%"],
        ["Bean count", "100 – 110 beans / 100 g"],
      ],
      packing: [
        ["Packaging", "65 kg jute bags"],
        ["Certification", "Rainforest / UTZ on request"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Min. quantity", "1 container"],
      ],
    },
  },
  {
    key: "riz",
    category: "raw",
    img: IMG("photo-1586201375761-83865001e31c"),
    fr: {
      name: "Riz",
      desc: "Riz blanc, étuvé et parfumé, conditionné pour l'export et adapté aux marchés de gros et de détail.",
      specs: [
        ["Types", "Blanc, étuvé, parfumé (jasmine, basmati)"],
        ["Origine", "Thaïlande, Vietnam, Inde, Pakistan"],
        ["Brisure", "5 % ou 25 %"],
        ["Humidité", "≤ 14 %"],
      ],
      packing: [
        ["Conditionnement", "Sacs PP 25 ou 50 kg"],
        ["Logistique", "Conteneur 20' / 40'"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Quantité min.", "1 conteneur"],
      ],
    },
    en: {
      name: "Rice",
      desc: "White, parboiled and fragrant rice, packed for export and suited to wholesale and retail markets.",
      specs: [
        ["Types", "White, parboiled, fragrant (jasmine, basmati)"],
        ["Origin", "Thailand, Vietnam, India, Pakistan"],
        ["Broken", "5% or 25%"],
        ["Moisture", "≤ 14%"],
      ],
      packing: [
        ["Packaging", "25 or 50 kg PP bags"],
        ["Logistics", "20' / 40' container"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Min. quantity", "1 container"],
      ],
    },
  },
  {
    key: "karite",
    category: "raw",
    img: "https://plus.unsplash.com/premium_photo-1676879544771-57b8c8c4447a?auto=format&fit=crop&w=1400&q=80",
    fr: {
      name: "Graine de karité pure",
      desc: "Graines de karité pures, issues d'une filière équitable de Côte d'Ivoire.",
      specs: [
        ["Origine", "Côte d'Ivoire, filière équitable"],
        ["Humidité", "≤ 8 %"],
        ["Matière grasse", "≥ 45 %"],
        ["Type", "Graines brutes séchées"],
      ],
      packing: [
        ["Conditionnement", "Sacs PP 50 kg"],
        ["Logistique", "Conteneur 20' / 40'"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Quantité min.", "1 conteneur"],
      ],
    },
    en: {
      name: "Pure shea nuts",
      desc: "Pure shea nuts from a fair-trade supply chain in Côte d'Ivoire.",
      specs: [
        ["Origin", "Côte d'Ivoire, fair-trade supply chain"],
        ["Moisture", "≤ 8%"],
        ["Fat content", "≥ 45%"],
        ["Type", "Dried raw nuts"],
      ],
      packing: [
        ["Packaging", "50 kg PP bags"],
        ["Logistics", "20' / 40' container"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Min. quantity", "1 container"],
      ],
    },
  },
  {
    key: "coque",
    category: "raw",
    img: "/assets/coque-cajou.jpg",
    fr: {
      name: "Coque de cajou",
      desc: "Coques brutes de noix de cajou pour valorisation énergétique et industrielle (CNSL, briquettes, combustible).",
      specs: [
        ["Origine", "Côte d'Ivoire"],
        ["Taux d'huile (CNSL)", "25 – 30 %"],
        ["Usages", "Énergie, extraction CNSL, briquettes"],
        ["Humidité", "≤ 10 %"],
      ],
      packing: [
        ["Conditionnement", "Vrac ou big-bags"],
        ["Logistique", "Conteneur 40'"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Quantité min.", "1 conteneur 40'"],
      ],
    },
    en: {
      name: "Cashew shells",
      desc: "Raw cashew nut shells for energy and industrial recovery (CNSL, briquettes, fuel).",
      specs: [
        ["Origin", "Côte d'Ivoire"],
        ["Oil content (CNSL)", "25 – 30%"],
        ["Uses", "Energy, CNSL extraction, briquettes"],
        ["Moisture", "≤ 10%"],
      ],
      packing: [
        ["Packaging", "Bulk or big-bags"],
        ["Logistics", "40' container"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Min. quantity", "1 × 40' container"],
      ],
    },
  },
  {
    key: "poissons",
    category: "frozen",
    img: IMG("photo-1741739813128-cb658a9a0f9a"),
    fr: {
      name: "Poissons",
      desc: "Poissons entiers et filets surgelés en mer ou à quai, avec calibre et glaçure maîtrisés selon votre cahier des charges.",
      specs: [
        ["Espèces", "Capitaine, thon, maquereau, sardine, merlu"],
        ["Surgélation", "En mer ou à quai, IQF ou bloc"],
        ["Température", "-18°C à -25°C"],
        ["Glaçure", "5 – 10 %"],
      ],
      packing: [
        ["Conditionnement", "Cartons 10 ou 20 kg"],
        ["Logistique", "Conteneur reefer -25°C"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Quantité min.", "1 conteneur reefer"],
      ],
    },
    en: {
      name: "Fish",
      desc: "Whole fish and fillets frozen at sea or at dock, with sizing and glazing controlled to your specification.",
      specs: [
        ["Species", "Capitaine, tuna, mackerel, sardine, hake"],
        ["Freezing", "At sea or at dock, IQF or block"],
        ["Temperature", "-18°C to -25°C"],
        ["Glazing", "5 – 10%"],
      ],
      packing: [
        ["Packaging", "10 or 20 kg cartons"],
        ["Logistics", "-25°C reefer container"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Min. quantity", "1 reefer container"],
      ],
    },
  },
  {
    key: "viandes",
    category: "frozen",
    img: IMG("photo-1607623814075-e51df1bdc82f"),
    fr: {
      name: "Viandes",
      desc: "Viandes bovines, ovines, volailles et porc, abattage contrôlé et découpe selon cahier des charges.",
      specs: [
        ["Types", "Bœuf, agneau, volaille, porc"],
        ["Certification", "Halal disponible sur demande"],
        ["Découpe", "Selon cahier des charges client"],
        ["Température", "-18°C"],
      ],
      packing: [
        ["Conditionnement", "Cartons 10 ou 25 kg"],
        ["Logistique", "Conteneur reefer -18°C"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Quantité min.", "1 conteneur reefer"],
      ],
    },
    en: {
      name: "Meats",
      desc: "Beef, lamb, poultry and pork, controlled slaughter and cutting to your specification.",
      specs: [
        ["Types", "Beef, lamb, poultry, pork"],
        ["Certification", "Halal available on request"],
        ["Cutting", "To client specification"],
        ["Temperature", "-18°C"],
      ],
      packing: [
        ["Packaging", "10 or 25 kg cartons"],
        ["Logistics", "-18°C reefer container"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Min. quantity", "1 reefer container"],
      ],
    },
  },
  {
    key: "autres",
    category: "frozen",
    img: IMG("photo-1518843875459-f738682238a6"),
    fr: {
      name: "Autres denrées congelées",
      desc: "Légumes, fruits et préparations congelées IQF pour l'industrie agroalimentaire et la distribution.",
      specs: [
        ["Gamme", "Légumes, fruits, préparations IQF"],
        ["Procédé", "Surgélation IQF"],
        ["Température", "-18°C"],
        ["Usage", "Industrie, restauration, distribution"],
      ],
      packing: [
        ["Conditionnement", "Cartons 10 kg ou sachets"],
        ["Logistique", "Conteneur reefer -18°C"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Quantité min.", "Selon référence"],
      ],
    },
    en: {
      name: "Other frozen goods",
      desc: "IQF vegetables, fruits and prepared foods for the food industry and retail.",
      specs: [
        ["Range", "Vegetables, fruits, IQF prepared foods"],
        ["Process", "IQF freezing"],
        ["Temperature", "-18°C"],
        ["Use", "Industry, catering, retail"],
      ],
      packing: [
        ["Packaging", "10 kg cartons or pouches"],
        ["Logistics", "-18°C reefer container"],
        ["Incoterms", "FOB, CFR, CIF"],
        ["Min. quantity", "Depending on item"],
      ],
    },
  },
];

export const productByKey = (key) => PRODUCTS.find((p) => p.key === key);
